/**
 * @deprecated
 * 群聊告警管理
 */

import { Card, Form, Button, Input, message, Modal, Popconfirm, Space } from "antd";
import { PlusOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import styles from "@/styles/pageContent.module.scss";
import { getWorkBotAlarmList, createWorkBotAlarm, deleteWorkBotAlarm, WorkbotAlarm, createWorkBotAlarmParams } from "@/service/workBot";
import { useEffect, useState } from "react";
import CommonTable from "@/components/commonTable";
import { useTable } from "@/utils/useTable";
import { formatTime } from "@/utils/formatTime";

function WorkBotAlarm() {
    const [createForm] = Form.useForm();
    const [searchForm] = Form.useForm();
    const [searchParams, setSearchParams] = useState<any>({});
    const [createModalVisible, setCreateModalVisible] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);

    // 使用 useTable 钩子管理表格数据
    const { page, limit, loading, data, totalCount, onPageChange, getData } = useTable({
        requestFunc: (params: any) => getWorkBotAlarmList(params),
        initRequest: false,
        searchParams
    });

    // 搜索
    const handleSearch = (values: any) => {
        setSearchParams(values);
        getData();
    };

    // 创建告警
    const handleCreate = async (values: any) => {
        setCreateLoading(true);
        try {
            const params: createWorkBotAlarmParams = {
                pairList: [
                    {
                        first: values.alarmType,
                        second: values.warningType
                    }
                ],
                workbotChatId: values.workbotChatId
            };
            await createWorkBotAlarm(params);
            message.success('创建成功');
            setCreateModalVisible(false);
            createForm.resetFields();
            getData(); // 刷新表格数据
        } catch (error) {
            message.error('创建失败');
        } finally {
            setCreateLoading(false);
        }
    };

    // 删除告警
    const handleDelete = async (id: number) => {
        try {
            await deleteWorkBotAlarm(id);
            message.success('删除成功');
            getData(); // 刷新表格数据
        } catch (error) {
            message.error('删除失败');
        }
    };

    // 表格列配置
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '群聊ID',
            dataIndex: 'workbotChatId',
            key: 'workbotChatId',
            width: 100,
        },
        {
            title: '报警类型',
            dataIndex: 'alarmType',
            key: 'alarmType',
            width: 120,
        },
        {
            title: '警告类型',
            dataIndex: 'warningType',
            key: 'warningType',
            width: 120,
        },
        {
            title: '创建时间',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 180,
            render: (text: string) => text ? formatTime(text) : '-',
        },
        {
            title: '更新时间',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            width: 180,
            render: (text: string) => text ? formatTime(text) : '-',
        },
        {
            title: '操作',
            key: 'action',
            width: 120,
            fixed: 'right' as const,
            render: (_: any, record: WorkbotAlarm) => (
                <Popconfirm
                    title="确定要删除此告警吗？"
                    onConfirm={() => handleDelete(record.id!)}
                    okText="确定"
                    cancelText="取消"
                >
                    <Button 
                        type="link" 
                        danger 
                        icon={<DeleteOutlined />}
                        size="small"
                    >
                        删除
                    </Button>
                </Popconfirm>
            ),
        },
    ];

    return (
        <Card bordered={false} className={styles.fixPageContentBox}>
            {/* 搜索表单 */}
            <Form
                form={searchForm}
                onFinish={handleSearch}
                layout="inline"
                style={{ marginBottom: 16 }}
            >
                <Form.Item
                    name="workbotChatId"
                    label="群聊ID"
                >
                    <Input placeholder="请输入群聊ID" style={{ width: 200 }} />
                </Form.Item>
                <Form.Item>
                    <Space>
                        <Button 
                            type="primary" 
                            htmlType="submit"
                            icon={<SearchOutlined />}
                        >
                            搜索
                        </Button>
                        <Button 
                            type="primary" 
                            icon={<PlusOutlined />}
                            onClick={() => setCreateModalVisible(true)}
                        >
                            新建
                        </Button>
                    </Space>
                </Form.Item>
            </Form>

            {/* 表格 */}
            <CommonTable
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: totalCount,
                    onChange: onPageChange,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `共 ${total} 条数据`,
                }}
                rowKey="id"
                scroll={{ x: 1000 }}
            />

            {/* 创建弹窗 */}
            <Modal
                title="新建告警"
                open={createModalVisible}
                onOk={() => createForm.submit()}
                onCancel={() => {
                    setCreateModalVisible(false);
                    createForm.resetFields();
                }}
                confirmLoading={createLoading}
                destroyOnClose
            >
                <Form
                    form={createForm}
                    onFinish={handleCreate}
                    layout="vertical"
                >
                    <Form.Item
                        name="workbotChatId"
                        label="群聊ID"
                        rules={[{ required: true, message: '请输入群聊ID' }]}
                    >
                        <Input placeholder="请输入群聊ID" type="number" />
                    </Form.Item>
                    <Form.Item
                        name="alarmType"
                        label="报警类型"
                        rules={[{ required: true, message: '请输入报警类型' }]}
                    >
                        <Input placeholder="请输入报警类型" type="number" />
                    </Form.Item>
                    <Form.Item
                        name="warningType"
                        label="警告类型"
                        rules={[{ required: true, message: '请输入警告类型' }]}
                    >
                        <Input placeholder="请输入警告类型" type="number" />
                    </Form.Item>
                </Form>
            </Modal>
        </Card>
    )
}

export default WorkBotAlarm;